var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 1.06095L6.58 6.60095C6.21 6.97095 6 7.48095 6 8.01095V18.0009C6 19.1009 6.9 20.0009 8 20.0009H17C17.8 20.0009 18.52 19.5209 18.84 18.7909L22.1 11.1809C22.94 9.20094 21.49 7.00095 19.34 7.00095H13.69L14.64 2.42095C14.74 1.92095 14.59 1.41095 14.23 1.05095C13.64 0.470946 12.7 0.470946 12.12 1.06095ZM2 20.0009C3.1 20.0009 4 19.1009 4 18.0009V10.0009C4 8.90094 3.1 8.00095 2 8.00095C0.9 8.00095 0 8.90094 0 10.0009V18.0009C0 19.1009 0.9 20.0009 2 20.0009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.a5dd4e3ddc1e119ea7ea2e52ee9b55cc.svg";
export { ForwardRef as ReactComponent };